import { jsx as _jsx } from "react/jsx-runtime";
import { BLACK, WHITE } from '@airtel/air-design-system';
import { TouchableOpacity, View } from 'react-native';
import { ACTIVE_NAVIGATION_BUTTON_COLOR, getCarouselNavigationButtonStyles } from './CarouselNavigationButtonStyles';
export var CarouselNavigationButton = props => {
  var disabled = props.disabled,
    Icon = props.Icon,
    onPress = props.onPress,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme;
  var carouselNavigationButtonStyles = getCarouselNavigationButtonStyles(props);
  var color = theme === 'dark' ? BLACK : WHITE;
  return _jsx(TouchableOpacity, Object.assign({
    disabled: disabled,
    onPress: onPress
  }, {
    children: _jsx(View, Object.assign({
      style: carouselNavigationButtonStyles.container
    }, {
      children: _jsx(Icon, {
        fontSize: 13,
        color: disabled ? ACTIVE_NAVIGATION_BUTTON_COLOR : color
      })
    }))
  }));
};